import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/news/")({
  // Legacy section from the previous site.
  loader: () => {
    throw redirect({ to: "/feed", statusCode: 301 });
  },
});
